// App.tsx — NFS bootstrap only. All feature code lives in plugin packages
// under plugins/ and is auto-discovered via `app.packages: all` in
// app-config.yaml.
//
// Cross-plugin route bindings connect "external routes" — placeholder route
// refs that one plugin exposes for another plugin to link to. For example:
//   - catalog's "Create Component" button → scaffolder's root page
//   - catalog's "View TechDocs" link → techdocs doc root
//   - scaffolder's "View TechDocs" link → techdocs doc root
//   - org's "Catalog Index" link → catalog's index page
// Without these bindings, cross-plugin navigation links would be broken.
//
// Custom scaffolder field extensions (SpannerDomainSelect, EnvironmentsAppSelect,
// GcpBusinessUnitsSelect, OktaToken) each live in their own frontend-plugin-module
// package under plugins/scaffolder/scaffolder-module-*/ and are auto-discovered via
// `app.packages: all`. No manual wiring is needed here.

import { createApp } from "@backstage/frontend-defaults";
import { apiDocsPlugin } from "@backstage/plugin-api-docs";
import { catalogPlugin } from "@backstage/plugin-catalog";
import { orgPlugin } from "@backstage/plugin-org";
import { scaffolderPlugin } from "@backstage/plugin-scaffolder";
import { techdocsPlugin } from "@backstage/plugin-techdocs";
import {
    techDocsLightBoxAddonModule,
    techDocsReportIssueAddonModule,
} from "@backstage/plugin-techdocs-module-addons-contrib/alpha";
import { scaffolderModuleDeprecatedTemplatePage } from "@internal/backstage-plugin-scaffolder-react";

const app = createApp({
    bindRoutes({ bind }) {
        bind(catalogPlugin.externalRoutes, {
            createComponent: scaffolderPlugin.routes.root,
            viewTechDoc: techdocsPlugin.routes.docRoot,
            createFromTemplate: scaffolderPlugin.routes.selectedTemplate,
        });
        bind(apiDocsPlugin.externalRoutes, {
            // registerApi: catalogImportPlugin.routes.importPage,
        });
        bind(scaffolderPlugin.externalRoutes, {
            // registerComponent: catalogImportPlugin.routes.importPage,
            viewTechDoc: techdocsPlugin.routes.docRoot,
        });
        bind(orgPlugin.externalRoutes, {
            catalogIndex: catalogPlugin.routes.catalogIndex,
        });
    },
    features: [
        techDocsReportIssueAddonModule,
        techDocsLightBoxAddonModule,
        scaffolderModuleDeprecatedTemplatePage,
    ],
});

export default app.createRoot();
